import {
  createAction,
  EMPTY_PRELOADED_FORMS,
  findFormSlotIds,
  FORMS_PRELOAD_TIMEOUT_MS,
  preloadForms,
  type PreloadedForms,
  withTimeout,
} from '@wix/communities-blog-client-common';
import { toMonitoredViewer } from '../../common/services/monitoring';
import type { NormalizedPost } from '../../common/types';
import { type PostPageThunkAction } from '../types';

export const fetchPreloadedFormsSuccess = createAction(
  'preloadedForms/FETCH_SUCCESS',
  (payload: PreloadedForms) => payload,
);

/**
 * Resolves the Wix Forms a post embeds through the ricos slot plugin before the first render. Runs
 * in the controller, on the server too, which is what puts the rendered form into the server HTML.
 * Bounded by `FORMS_PRELOAD_TIMEOUT_MS` so a slow Forms API never holds the post page; a failure is
 * reported and the blocks fetch their form on the client instead.
 * Imports stay React- and CSS-free so the OOI worker build compiles.
 */
export default function fetchPreloadedForms(post: NormalizedPost): PostPageThunkAction {
  return async (dispatch, _, { flowAPI }) => {
    const formIds = findFormSlotIds(post.content);
    if (formIds.length === 0) {
      return;
    }
    const forms = await toMonitoredViewer(
      flowAPI.panoramaClient,
      'post-page.preload-forms',
      () =>
        withTimeout(
          preloadForms({
            httpClient: flowAPI.httpClient,
            formIds,
            language: flowAPI.environment.language,
          }),
          FORMS_PRELOAD_TIMEOUT_MS,
          'preloadForms',
        ),
      false,
    );
    dispatch(fetchPreloadedFormsSuccess(forms ?? EMPTY_PRELOADED_FORMS));
  };
}
